
export default function StatsBar() {
  const stats = [
    { value: '500+', label: 'Products Reviewed', icon: 'ri-box-3-line' },
    { value: '120K+', label: 'Happy Users', icon: 'ri-user-smile-line' },
    { value: '98%', label: 'Satisfaction Rate', icon: 'ri-heart-3-line' },
    { value: '$2M+', label: 'Saved by Users', icon: 'ri-money-dollar-circle-line' },
  ];

  return (
    <section className="py-16 bg-carbon-900 border-y border-white/5">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {stats.map((stat) => (
            <div key={stat.label} className="flex items-center gap-4 justify-center">
              <div className="w-11 h-11 bg-white/5 border border-white/10 flex items-center justify-center flex-shrink-0">
                <i className={`${stat.icon} text-neon text-lg`}></i>
              </div>
              <div>
                <div className="text-2xl font-bold text-white tracking-tight">{stat.value}</div>
                <div className="text-xs text-white/40">{stat.label}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
